// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Sidebar - Dark theme (matches IdP dark design)
 */

.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 100vh;
  background: var(--bg-card);
  border-right: 1px solid var(--border);
  color: var(--text-primary);
  overflow: hidden;
  transition: transform var(--transition-normal) ease, width 0.25s ease;
  z-index: 1100;
  box-shadow: var(--shadow-lg);
  transform: translateX(0);
  display: flex;
  flex-direction: column;
}

/* Mobile: Hidden by default */
@media (max-width: 992px) {
  .sidebar {
    position: fixed;
    transform: translateX(-100%);
    z-index: 1000;
    width: 240px;
    box-shadow: var(--shadow-lg);
  }

  .sidebar.open {
    transform: translateX(0);
  }
}

@media (min-width: 993px) {
  .sidebar {
    transform: translateX(0) !important;
  }
}

/* Overlay for mobile */
.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 900;
  opacity: 0;
  transition: opacity var(--transition-normal);
}

.sidebar-overlay.visible {
  display: block;
  opacity: 1;
}

/* Scrollbar */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
  background: var(--slate-300);
  border-radius: 3px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: var(--slate-400);
}

/* Sidebar Content (es el que hace scroll; la marca queda fija arriba) */
.sidebar-content {
  padding: var(--spacing-md) 0;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.sidebar-controls {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.55rem 0.6rem 0.65rem;
  border-top: 1px solid var(--border);
  margin-top: auto;
  background: var(--bg-card);
  position: sticky;
  bottom: 0;
}

.sidebar-control-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  flex: 1 1;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  border-radius: 8px;
  padding: 0.42rem;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.15s ease;
}

.sidebar-control-btn .sidebar-label {
  display: none;
}

.sidebar-control-btn:hover {
  background: var(--slate-200);
  color: var(--text-primary);
  border-color: var(--slate-300);
}

.sidebar-control-btn-primary {
  border-color: rgba(var(--accent-rgb), 0.35);
  color: var(--accent-l);
}

.sidebar-control-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* Brand Section */
.sidebar-brand {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  /* Misma altura que la barra superior para que las dos líneas inferiores
     queden a la misma altura (ver --app-topbar-h en MainLayout.css). */
  flex: none;
  height: var(--app-topbar-h, 69px);
  box-sizing: border-box;
  padding: 0 var(--spacing-lg);
  cursor: pointer;
  border-bottom: 1px solid var(--border);
  transition: background-color var(--transition-fast);
  -webkit-user-select: none;
          user-select: none;
}

.sidebar-brand:hover {
  background-color: var(--bg-toolbar);
}

.sidebar-brand:focus {
  outline: 2px solid var(--accent);
  outline-offset: -2px;
}

.sidebar-brand-icon {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  background: linear-gradient(135deg, var(--accent), var(--accent-2));
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: var(--fw-bold);
  font-size: var(--text-base);
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(var(--accent-rgb),.4);
}

.sidebar-brand-texts {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1 1;
  min-width: 0;
}

.sidebar-brand-title {
  font-weight: var(--fw-bold);
  font-size: var(--text-sm);
  color: var(--text-primary);
  line-height: 1.2;
}

.sidebar-brand-subtitle {
  font-weight: var(--fw-regular);
  font-size: var(--text-xs);
  color: var(--text-muted);
  line-height: 1.2;
}

/* Company Info Section */
.sidebar-company {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
  padding: var(--spacing-sm) var(--spacing-lg);
  border-bottom: 1px solid var(--border);
  background: var(--bg-toolbar);
}

.sidebar-company-label {
  display: block;
  font-size: var(--text-xs);
  text-transform: uppercase;
  color: var(--slate-400);
  letter-spacing: 0.8px;
  margin-bottom: 2px;
  font-weight: var(--fw-semibold);
}

.sidebar-company-name {
  font-size: var(--text-sm);
  font-weight: var(--fw-medium);
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-company-label {
  display: block;
  font-size: var(--text-xs);
  text-transform: uppercase;
  color: var(--slate-400);
  letter-spacing: 0.5px;
  margin-bottom: 2px;
  font-weight: var(--fw-semibold);
}

.sidebar-company-name {
  font-size: var(--text-sm);
  font-weight: var(--fw-medium);
  color: var(--slate-900);
}


/* Navigation */
.sidebar-nav {
  flex: 1 1;
  padding: var(--spacing-md) 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-y: auto;
}

/* Link Styles */
.sidebar-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: 8px var(--spacing-lg);
  color: var(--text-secondary);
  text-decoration: none;
  font-size: var(--text-sm);
  border-left: 3px solid transparent;
  transition: all var(--transition-fast);
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  font-family: inherit;
  font-weight: var(--fw-regular);
}

.sidebar-link:hover {
  background-color: var(--bg-toolbar);
  color: var(--text-primary);
}

.sidebar-link.active {
  background-color: rgba(var(--accent-rgb),.12);
  color: var(--accent-l);
  border-left: 3px solid var(--accent);
  font-weight: var(--fw-semibold);
}

.sidebar-link.not-implemented {
  opacity: 0.5;
  cursor: not-allowed;
}

.sidebar-link.not-implemented:hover {
  background-color: transparent;
  color: var(--text-secondary);
}

.sidebar-link.sidebar-sublink {
  padding: 6px var(--spacing-lg) 6px calc(var(--spacing-lg) + 18px + var(--spacing-md));
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.sidebar-link.sidebar-sublink:hover {
  color: var(--accent-l);
}

.sidebar-link.sidebar-sublink.active {
  color: var(--accent-l);
  background-color: rgba(var(--accent-rgb),.1);
}

.sidebar-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  stroke-width: 1.5;
}

.sidebar-label {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.sidebar-badge {
  font-size: 12px;
  margin-left: auto;
  flex-shrink: 0;
}

/* Accordion */
.sidebar-accordion {
  margin: 0;
}

.sidebar-accordion-toggle {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  width: 100%;
  padding: 8px var(--spacing-lg);
  background: none;
  border: none;
  color: var(--slate-600);
  font-size: var(--text-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  font-family: inherit;
  font-weight: var(--fw-regular);
  border-left: 3px solid transparent;
}

.sidebar-accordion-toggle:hover {
  background-color: var(--slate-50);
  color: var(--blue-600);
}

.sidebar-accordion-toggle.active {
  background-color: var(--blue-50);
  color: var(--blue-600);
  border-left-color: var(--blue-600);
  font-weight: var(--fw-semibold);
}

.sidebar-accordion-toggle:focus {
  outline: 2px solid var(--blue-600);
  outline-offset: -2px;
}

.sidebar-arrow {
  margin-left: auto;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: transform var(--transition-fast);
  stroke-width: 2;
}

.sidebar-accordion-toggle.active .sidebar-arrow {
  transform: rotate(180deg);
}

/* Accordion Content */
.sidebar-accordion-content {
  background-color: var(--slate-50);
  border-top: 1px solid var(--slate-200);
  border-bottom: 1px solid var(--slate-200);
}

/* ── Section Labels ── */
/* Domain separator labels (e.g. INFRAESTRUCTURA, CONECTIVIDAD) */
.sidebar-section-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem var(--spacing-lg) 0.35rem;
  font-size: 0.63rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
  -webkit-user-select: none;
          user-select: none;
  margin-top: 0.25rem;
  border-top: 1px solid var(--border);
}

.sidebar-section-label:first-child {
  margin-top: 0;
  border-top: none;
}

/* ── Domain Color Dot ── */
/* Colored dot shown in accordion toggles instead of icon */
.sidebar-group-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  opacity: 0.85;
  transition: opacity 0.15s, transform 0.15s;
}

.sidebar-accordion-toggle:hover .sidebar-group-dot,
.sidebar-accordion-toggle.active .sidebar-group-dot {
  opacity: 1;
  transform: scale(1.15);
}

/* ── Menú compacto: favoritos y secciones ───────────────────────────────────
   El modo «secciones» deja solo los títulos en el primer nivel. Los favoritos
   van arriba del todo para que el acceso diario no dependa de recordar en qué
   sección vive cada cosa. */

.sidebar-favorites {
  margin-bottom: 0.25rem;
}

.sidebar-favorites .sidebar-section-label {
  margin-top: 0;
  border-top: none;
}

.sidebar-favorite {
  position: relative;
  display: flex;
  align-items: center;
}

.sidebar-favorite-link {
  /* Hueco a la derecha para el aspa de quitar, sin que el texto se monte. */
  padding-right: 34px;
}

.sidebar-favorite-star {
  color: var(--accent-l);
  fill: rgba(var(--accent-rgb), 0.22);
}

.sidebar-favorite-scope {
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  margin-right: 4px;
  opacity: 0.55;
  flex-shrink: 0;
}

.sidebar-favorite-scope svg {
  width: 13px;
  height: 13px;
  stroke-width: 1.6;
}

.sidebar-favorite-remove {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  opacity: 0;
  transition: opacity var(--transition-fast), background-color var(--transition-fast);
}

.sidebar-favorite:hover .sidebar-favorite-remove,
.sidebar-favorite-remove:focus-visible {
  opacity: 1;
}

.sidebar-favorite-remove:hover {
  background: rgba(var(--accent-rgb), 0.14);
  color: var(--accent-l);
}

.sidebar-favorite-remove svg {
  width: 13px;
  height: 13px;
  stroke-width: 2;
}

.sidebar-fixed-links {
  padding-bottom: 0.25rem;
  border-bottom: 1px solid var(--border);
  margin-bottom: 0.25rem;
}

.sidebar-sections {
  display: flex;
  flex-direction: column;
}

/* Sección con un único grupo: sus entradas se pintan directamente, sin la
   cabecera de acordeón que repetiría el nombre de la sección. */
.sidebar-section-flat {
  display: flex;
  flex-direction: column;
  padding-top: 2px;
}

.sidebar-section-link {
  font-weight: var(--fw-medium, 500);
  padding-top: 10px;
  padding-bottom: 10px;
}

.sidebar-section-arrow {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  opacity: 0.45;
  transition: transform var(--transition-fast), opacity var(--transition-fast);
  stroke-width: 2;
}

.sidebar-section-link:hover .sidebar-section-arrow {
  transform: translateX(2px);
  opacity: 0.9;
}

.sidebar-section-panel {
  display: flex;
  flex-direction: column;
}

.sidebar-back-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px var(--spacing-lg);
  margin-bottom: 0.15rem;
  border: none;
  background: none;
  color: var(--text-muted);
  font-family: inherit;
  font-size: var(--text-xs);
  cursor: pointer;
  text-align: left;
  transition: color var(--transition-fast);
}

.sidebar-back-btn:hover {
  color: var(--accent-l);
}

.sidebar-back-icon {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.sidebar-section-title {
  padding: 0 var(--spacing-lg) 0.35rem;
  font-size: 0.63rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
  -webkit-user-select: none;
          user-select: none;
}

/* ── Menú de módulo (Estaciones de trabajo y futuros módulos) ──────────────
   Dos accesos hacia arriba y luego las vistas del módulo. El segundo («Infra-
   estructura») va un punto más apagado que el primero para dejar claro cuál es
   la salida completa y cuál la intermedia. */
.sidebar-context-panel {
  padding-top: 0.15rem;
}

.sidebar-back-btn--section {
  color: var(--text-secondary);
  opacity: 0.85;
  margin-bottom: 0.35rem;
}

.sidebar-context-panel .sidebar-section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-top: 0.45rem;
  margin-top: 0.15rem;
  border-top: 1px solid var(--border);
  color: var(--text-secondary);
}

.sidebar-context-panel .sidebar-section-title .sidebar-icon {
  width: 14px;
  height: 14px;
  stroke-width: 2;
}

.sidebar-context-panel .sidebar-link {
  padding-left: calc(var(--spacing-lg) + 4px);
}

/* Accesos fijos que sobreviven dentro de un módulo (Dashboard, Planes,
   Documentación, Ubicaciones, Contactos). Van separados por una línea fina
   para que se lean como «esto no es del módulo, pero lo tienes a mano». */
.sidebar-context-fixed {
  margin-top: 0.5rem;
  padding-top: 0.45rem;
  border-top: 1px dashed var(--border);
}

.sidebar-customize-link {
  margin-top: 0.4rem;
  border-top: 1px dashed var(--border);
  padding-top: 10px;
}

.sidebar-customize-link .sidebar-icon {
  color: var(--accent-l);
  fill: rgba(var(--accent-rgb), 0.18);
}


@media (max-width: 992px) {
  .sidebar {
    width: 240px;
  }

  .sidebar-brand-subtitle {
    display: none;
  }

  .sidebar-label {
    font-size: var(--text-sm);
  }

  .sidebar-icon {
    width: 16px;
    height: 16px;
  }
}

@media (max-width: 576px) {
  .sidebar {
    width: 100%;
    max-width: 240px;
  }

  .sidebar-brand-icon {
    width: 32px;
    height: 32px;
  }

  .sidebar-brand-title {
    font-size: var(--text-xs);
  }

  .sidebar-company-name {
    font-size: var(--text-xs);
  }

  .sidebar-link,
  .sidebar-accordion-toggle {
    padding: 6px var(--spacing-md);
    font-size: var(--text-xs);
  }

  .sidebar-link.sidebar-sublink {
    padding: 4px var(--spacing-md) 4px calc(var(--spacing-md) + 16px + var(--spacing-sm));
  }

  .sidebar-icon {
    width: 16px;
    height: 16px;
  }

  .sidebar-label {
    display: none;
  }

  .sidebar-badge {
    display: none;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .sidebar,
  .sidebar-link,
  .sidebar-accordion-toggle,
  .sidebar-arrow {
    transition: none;
  }
}

/* Dark Mode Support (if implemented) */
@media (prefers-color-scheme: dark) {
  /* Future dark mode styles can be added here */
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;EAC1B,gBAAgB;EAChB,qEAAqE;EACrE,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,4BAA4B;IAC5B,aAAa;IACb,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,4BAA4B;EAC5B,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,SAAO;EACP,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB;uEACqE;EACrE,UAAU;EACV,iCAAiC;EACjC,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,sCAAsC;EACtC,mDAAmD;EACnD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mEAAmE;EACnE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,SAAO;EACP,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,4CAA4C;EAC5C,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;AACzB;;;AAGA,eAAe;AACf;EACE,SAAO;EACP,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,4BAA4B;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;EACtB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qFAAqF;EACrF,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B,2DAA2D;AAC3D;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;4BAG4B;;AAE5B;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0EAA0E;EAC1E,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,mFAAmF;AACrF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;gEACgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,4EAA4E;EAC5E,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;6CAG6C;AAC7C;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;0EAE0E;AAC1E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;;AAGA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,qFAAqF;EACvF;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA,uCAAuC;AACvC;EACE,8CAA8C;AAChD","sourcesContent":["/**\r\n * Sidebar - Dark theme (matches IdP dark design)\r\n */\r\n\r\n.sidebar {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 240px;\r\n  height: 100vh;\r\n  background: var(--bg-card);\r\n  border-right: 1px solid var(--border);\r\n  color: var(--text-primary);\r\n  overflow: hidden;\r\n  transition: transform var(--transition-normal) ease, width 0.25s ease;\r\n  z-index: 1100;\r\n  box-shadow: var(--shadow-lg);\r\n  transform: translateX(0);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Mobile: Hidden by default */\r\n@media (max-width: 992px) {\r\n  .sidebar {\r\n    position: fixed;\r\n    transform: translateX(-100%);\r\n    z-index: 1000;\r\n    width: 240px;\r\n    box-shadow: var(--shadow-lg);\r\n  }\r\n\r\n  .sidebar.open {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@media (min-width: 993px) {\r\n  .sidebar {\r\n    transform: translateX(0) !important;\r\n  }\r\n}\r\n\r\n/* Overlay for mobile */\r\n.sidebar-overlay {\r\n  display: none;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 900;\r\n  opacity: 0;\r\n  transition: opacity var(--transition-normal);\r\n}\r\n\r\n.sidebar-overlay.visible {\r\n  display: block;\r\n  opacity: 1;\r\n}\r\n\r\n/* Scrollbar */\r\n.sidebar::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.sidebar::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.sidebar::-webkit-scrollbar-thumb {\r\n  background: var(--slate-300);\r\n  border-radius: 3px;\r\n}\r\n\r\n.sidebar::-webkit-scrollbar-thumb:hover {\r\n  background: var(--slate-400);\r\n}\r\n\r\n/* Sidebar Content (es el que hace scroll; la marca queda fija arriba) */\r\n.sidebar-content {\r\n  padding: var(--spacing-md) 0;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--spacing-md);\r\n}\r\n\r\n.sidebar-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  padding: 0.55rem 0.6rem 0.65rem;\r\n  border-top: 1px solid var(--border);\r\n  margin-top: auto;\r\n  background: var(--bg-card);\r\n  position: sticky;\r\n  bottom: 0;\r\n}\r\n\r\n.sidebar-control-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0;\r\n  flex: 1;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  border-radius: 8px;\r\n  padding: 0.42rem;\r\n  font-size: 0.75rem;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.sidebar-control-btn .sidebar-label {\r\n  display: none;\r\n}\r\n\r\n.sidebar-control-btn:hover {\r\n  background: var(--slate-200);\r\n  color: var(--text-primary);\r\n  border-color: var(--slate-300);\r\n}\r\n\r\n.sidebar-control-btn-primary {\r\n  border-color: rgba(var(--accent-rgb), 0.35);\r\n  color: var(--accent-l);\r\n}\r\n\r\n.sidebar-control-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Brand Section */\r\n.sidebar-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-md);\r\n  /* Misma altura que la barra superior para que las dos líneas inferiores\r\n     queden a la misma altura (ver --app-topbar-h en MainLayout.css). */\r\n  flex: none;\r\n  height: var(--app-topbar-h, 69px);\r\n  box-sizing: border-box;\r\n  padding: 0 var(--spacing-lg);\r\n  cursor: pointer;\r\n  border-bottom: 1px solid var(--border);\r\n  transition: background-color var(--transition-fast);\r\n  user-select: none;\r\n}\r\n\r\n.sidebar-brand:hover {\r\n  background-color: var(--bg-toolbar);\r\n}\r\n\r\n.sidebar-brand:focus {\r\n  outline: 2px solid var(--accent);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.sidebar-brand-icon {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: var(--radius-md);\r\n  background: linear-gradient(135deg, var(--accent), var(--accent-2));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #ffffff;\r\n  font-weight: var(--fw-bold);\r\n  font-size: var(--text-base);\r\n  flex-shrink: 0;\r\n  box-shadow: 0 4px 12px rgba(var(--accent-rgb),.4);\r\n}\r\n\r\n.sidebar-brand-texts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.sidebar-brand-title {\r\n  font-weight: var(--fw-bold);\r\n  font-size: var(--text-sm);\r\n  color: var(--text-primary);\r\n  line-height: 1.2;\r\n}\r\n\r\n.sidebar-brand-subtitle {\r\n  font-weight: var(--fw-regular);\r\n  font-size: var(--text-xs);\r\n  color: var(--text-muted);\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Company Info Section */\r\n.sidebar-company {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--spacing-xs);\r\n  padding: var(--spacing-sm) var(--spacing-lg);\r\n  border-bottom: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.sidebar-company-label {\r\n  display: block;\r\n  font-size: var(--text-xs);\r\n  text-transform: uppercase;\r\n  color: var(--slate-400);\r\n  letter-spacing: 0.8px;\r\n  margin-bottom: 2px;\r\n  font-weight: var(--fw-semibold);\r\n}\r\n\r\n.sidebar-company-name {\r\n  font-size: var(--text-sm);\r\n  font-weight: var(--fw-medium);\r\n  color: var(--text-primary);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.sidebar-company-label {\r\n  display: block;\r\n  font-size: var(--text-xs);\r\n  text-transform: uppercase;\r\n  color: var(--slate-400);\r\n  letter-spacing: 0.5px;\r\n  margin-bottom: 2px;\r\n  font-weight: var(--fw-semibold);\r\n}\r\n\r\n.sidebar-company-name {\r\n  font-size: var(--text-sm);\r\n  font-weight: var(--fw-medium);\r\n  color: var(--slate-900);\r\n}\r\n\r\n\r\n/* Navigation */\r\n.sidebar-nav {\r\n  flex: 1;\r\n  padding: var(--spacing-md) 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* Link Styles */\r\n.sidebar-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-md);\r\n  padding: 8px var(--spacing-lg);\r\n  color: var(--text-secondary);\r\n  text-decoration: none;\r\n  font-size: var(--text-sm);\r\n  border-left: 3px solid transparent;\r\n  transition: all var(--transition-fast);\r\n  cursor: pointer;\r\n  border: none;\r\n  background: none;\r\n  width: 100%;\r\n  font-family: inherit;\r\n  font-weight: var(--fw-regular);\r\n}\r\n\r\n.sidebar-link:hover {\r\n  background-color: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sidebar-link.active {\r\n  background-color: rgba(var(--accent-rgb),.12);\r\n  color: var(--accent-l);\r\n  border-left: 3px solid var(--accent);\r\n  font-weight: var(--fw-semibold);\r\n}\r\n\r\n.sidebar-link.not-implemented {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.sidebar-link.not-implemented:hover {\r\n  background-color: transparent;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sidebar-link.sidebar-sublink {\r\n  padding: 6px var(--spacing-lg) 6px calc(var(--spacing-lg) + 18px + var(--spacing-md));\r\n  font-size: var(--text-xs);\r\n  color: var(--text-muted);\r\n}\r\n\r\n.sidebar-link.sidebar-sublink:hover {\r\n  color: var(--accent-l);\r\n}\r\n\r\n.sidebar-link.sidebar-sublink.active {\r\n  color: var(--accent-l);\r\n  background-color: rgba(var(--accent-rgb),.1);\r\n}\r\n\r\n.sidebar-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  flex-shrink: 0;\r\n  stroke-width: 1.5;\r\n}\r\n\r\n.sidebar-label {\r\n  flex: 1;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-align: left;\r\n}\r\n\r\n.sidebar-badge {\r\n  font-size: 12px;\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Accordion */\r\n.sidebar-accordion {\r\n  margin: 0;\r\n}\r\n\r\n.sidebar-accordion-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-md);\r\n  width: 100%;\r\n  padding: 8px var(--spacing-lg);\r\n  background: none;\r\n  border: none;\r\n  color: var(--slate-600);\r\n  font-size: var(--text-sm);\r\n  cursor: pointer;\r\n  transition: all var(--transition-fast);\r\n  font-family: inherit;\r\n  font-weight: var(--fw-regular);\r\n  border-left: 3px solid transparent;\r\n}\r\n\r\n.sidebar-accordion-toggle:hover {\r\n  background-color: var(--slate-50);\r\n  color: var(--blue-600);\r\n}\r\n\r\n.sidebar-accordion-toggle.active {\r\n  background-color: var(--blue-50);\r\n  color: var(--blue-600);\r\n  border-left-color: var(--blue-600);\r\n  font-weight: var(--fw-semibold);\r\n}\r\n\r\n.sidebar-accordion-toggle:focus {\r\n  outline: 2px solid var(--blue-600);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.sidebar-arrow {\r\n  margin-left: auto;\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n  transition: transform var(--transition-fast);\r\n  stroke-width: 2;\r\n}\r\n\r\n.sidebar-accordion-toggle.active .sidebar-arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* Accordion Content */\r\n.sidebar-accordion-content {\r\n  background-color: var(--slate-50);\r\n  border-top: 1px solid var(--slate-200);\r\n  border-bottom: 1px solid var(--slate-200);\r\n}\r\n\r\n/* ── Section Labels ── */\r\n/* Domain separator labels (e.g. INFRAESTRUCTURA, CONECTIVIDAD) */\r\n.sidebar-section-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 1rem var(--spacing-lg) 0.35rem;\r\n  font-size: 0.63rem;\r\n  font-weight: 700;\r\n  letter-spacing: 1px;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  user-select: none;\r\n  margin-top: 0.25rem;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.sidebar-section-label:first-child {\r\n  margin-top: 0;\r\n  border-top: none;\r\n}\r\n\r\n/* ── Domain Color Dot ── */\r\n/* Colored dot shown in accordion toggles instead of icon */\r\n.sidebar-group-dot {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  opacity: 0.85;\r\n  transition: opacity 0.15s, transform 0.15s;\r\n}\r\n\r\n.sidebar-accordion-toggle:hover .sidebar-group-dot,\r\n.sidebar-accordion-toggle.active .sidebar-group-dot {\r\n  opacity: 1;\r\n  transform: scale(1.15);\r\n}\r\n\r\n/* ── Menú compacto: favoritos y secciones ───────────────────────────────────\r\n   El modo «secciones» deja solo los títulos en el primer nivel. Los favoritos\r\n   van arriba del todo para que el acceso diario no dependa de recordar en qué\r\n   sección vive cada cosa. */\r\n\r\n.sidebar-favorites {\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.sidebar-favorites .sidebar-section-label {\r\n  margin-top: 0;\r\n  border-top: none;\r\n}\r\n\r\n.sidebar-favorite {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.sidebar-favorite-link {\r\n  /* Hueco a la derecha para el aspa de quitar, sin que el texto se monte. */\r\n  padding-right: 34px;\r\n}\r\n\r\n.sidebar-favorite-star {\r\n  color: var(--accent-l);\r\n  fill: rgba(var(--accent-rgb), 0.22);\r\n}\r\n\r\n.sidebar-favorite-scope {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  margin-left: auto;\r\n  margin-right: 4px;\r\n  opacity: 0.55;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.sidebar-favorite-scope svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  stroke-width: 1.6;\r\n}\r\n\r\n.sidebar-favorite-remove {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 20px;\r\n  height: 20px;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  transition: opacity var(--transition-fast), background-color var(--transition-fast);\r\n}\r\n\r\n.sidebar-favorite:hover .sidebar-favorite-remove,\r\n.sidebar-favorite-remove:focus-visible {\r\n  opacity: 1;\r\n}\r\n\r\n.sidebar-favorite-remove:hover {\r\n  background: rgba(var(--accent-rgb), 0.14);\r\n  color: var(--accent-l);\r\n}\r\n\r\n.sidebar-favorite-remove svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  stroke-width: 2;\r\n}\r\n\r\n.sidebar-fixed-links {\r\n  padding-bottom: 0.25rem;\r\n  border-bottom: 1px solid var(--border);\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.sidebar-sections {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Sección con un único grupo: sus entradas se pintan directamente, sin la\r\n   cabecera de acordeón que repetiría el nombre de la sección. */\r\n.sidebar-section-flat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-top: 2px;\r\n}\r\n\r\n.sidebar-section-link {\r\n  font-weight: var(--fw-medium, 500);\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.sidebar-section-arrow {\r\n  width: 15px;\r\n  height: 15px;\r\n  flex-shrink: 0;\r\n  opacity: 0.45;\r\n  transition: transform var(--transition-fast), opacity var(--transition-fast);\r\n  stroke-width: 2;\r\n}\r\n\r\n.sidebar-section-link:hover .sidebar-section-arrow {\r\n  transform: translateX(2px);\r\n  opacity: 0.9;\r\n}\r\n\r\n.sidebar-section-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sidebar-back-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px var(--spacing-lg);\r\n  margin-bottom: 0.15rem;\r\n  border: none;\r\n  background: none;\r\n  color: var(--text-muted);\r\n  font-family: inherit;\r\n  font-size: var(--text-xs);\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: color var(--transition-fast);\r\n}\r\n\r\n.sidebar-back-btn:hover {\r\n  color: var(--accent-l);\r\n}\r\n\r\n.sidebar-back-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n  stroke-width: 2;\r\n}\r\n\r\n.sidebar-section-title {\r\n  padding: 0 var(--spacing-lg) 0.35rem;\r\n  font-size: 0.63rem;\r\n  font-weight: 700;\r\n  letter-spacing: 1px;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  user-select: none;\r\n}\r\n\r\n/* ── Menú de módulo (Estaciones de trabajo y futuros módulos) ──────────────\r\n   Dos accesos hacia arriba y luego las vistas del módulo. El segundo («Infra-\r\n   estructura») va un punto más apagado que el primero para dejar claro cuál es\r\n   la salida completa y cuál la intermedia. */\r\n.sidebar-context-panel {\r\n  padding-top: 0.15rem;\r\n}\r\n\r\n.sidebar-back-btn--section {\r\n  color: var(--text-secondary);\r\n  opacity: 0.85;\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.sidebar-context-panel .sidebar-section-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding-top: 0.45rem;\r\n  margin-top: 0.15rem;\r\n  border-top: 1px solid var(--border);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.sidebar-context-panel .sidebar-section-title .sidebar-icon {\r\n  width: 14px;\r\n  height: 14px;\r\n  stroke-width: 2;\r\n}\r\n\r\n.sidebar-context-panel .sidebar-link {\r\n  padding-left: calc(var(--spacing-lg) + 4px);\r\n}\r\n\r\n/* Accesos fijos que sobreviven dentro de un módulo (Dashboard, Planes,\r\n   Documentación, Ubicaciones, Contactos). Van separados por una línea fina\r\n   para que se lean como «esto no es del módulo, pero lo tienes a mano». */\r\n.sidebar-context-fixed {\r\n  margin-top: 0.5rem;\r\n  padding-top: 0.45rem;\r\n  border-top: 1px dashed var(--border);\r\n}\r\n\r\n.sidebar-customize-link {\r\n  margin-top: 0.4rem;\r\n  border-top: 1px dashed var(--border);\r\n  padding-top: 10px;\r\n}\r\n\r\n.sidebar-customize-link .sidebar-icon {\r\n  color: var(--accent-l);\r\n  fill: rgba(var(--accent-rgb), 0.18);\r\n}\r\n\r\n\r\n@media (max-width: 992px) {\r\n  .sidebar {\r\n    width: 240px;\r\n  }\r\n\r\n  .sidebar-brand-subtitle {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar-label {\r\n    font-size: var(--text-sm);\r\n  }\r\n\r\n  .sidebar-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .sidebar {\r\n    width: 100%;\r\n    max-width: 240px;\r\n  }\r\n\r\n  .sidebar-brand-icon {\r\n    width: 32px;\r\n    height: 32px;\r\n  }\r\n\r\n  .sidebar-brand-title {\r\n    font-size: var(--text-xs);\r\n  }\r\n\r\n  .sidebar-company-name {\r\n    font-size: var(--text-xs);\r\n  }\r\n\r\n  .sidebar-link,\r\n  .sidebar-accordion-toggle {\r\n    padding: 6px var(--spacing-md);\r\n    font-size: var(--text-xs);\r\n  }\r\n\r\n  .sidebar-link.sidebar-sublink {\r\n    padding: 4px var(--spacing-md) 4px calc(var(--spacing-md) + 16px + var(--spacing-sm));\r\n  }\r\n\r\n  .sidebar-icon {\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n\r\n  .sidebar-label {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar-badge {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Reduced Motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .sidebar,\r\n  .sidebar-link,\r\n  .sidebar-accordion-toggle,\r\n  .sidebar-arrow {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n/* Dark Mode Support (if implemented) */\r\n@media (prefers-color-scheme: dark) {\r\n  /* Future dark mode styles can be added here */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
